import { AddressForm as AddressFormData, AddressTypeCode, AddressTypes } from '../../../global-types/addresses';
import { EnvelopeType } from '../../../global-types/envelope';

type DefaultAddressOptions = {
  isUK: boolean | undefined;
  selectedEnvelope: EnvelopeType;
  currentAddressType: AddressTypes;
  skipUspsValidation: boolean;
};

export const getDefaultAddressOptions = ({
  isUK,
  selectedEnvelope,
  currentAddressType,
  skipUspsValidation,
}: DefaultAddressOptions) => {
  const defaultAddressOptions: Partial<AddressFormData> = {
    country_code: isUK ? 'UK' : 'USA',
    skip_usps_validation: skipUspsValidation,
    address_type_code:
      currentAddressType === AddressTypes.RECIPIENT ? AddressTypeCode.RECIPIENT : AddressTypeCode.SENDER,
    envelope: selectedEnvelope || null,
  };
  return defaultAddressOptions;
};
